"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.speakers = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _MetricGroup = _interopRequireDefault(require("./MetricGroup"));

require("./style.css");

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Todo: Styling is repeating for each component.
//  Can we live with this or should global styles
//  be created? How does style-components handle
//  relationships between components?
var StyledMetrics = function StyledMetrics(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics"
  }, rest), children);
};

var StyledColumn = function StyledColumn(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics-column"
  }, rest), children);
};

var StyledRow = function StyledRow(_ref3) {
  var children = _ref3.children,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics-row"
  }, rest), children);
};

var MetricTitle = function MetricTitle(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "metrics-title"
  }, rest), children);
};

var speakers = {
  AGENT: "Agent",
  CUSTOMER: "Customer",
  CALLER: "Customer",
  BOT: "Bot",
  OVERALL: "Overall"
};
/* eslint react/prefer-stateless-function:0 */

exports.speakers = speakers;

var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Index.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        metrics = _this$props.metrics,
        title = _this$props.title,
        _this$props$isChatTex = _this$props.isChatTextMedia,
        isChatTextMedia = _this$props$isChatTex === void 0 ? false : _this$props$isChatTex;

    if (!(metrics && _.isArray(metrics))) {
      return /*#__PURE__*/_react["default"].createElement("p", null, "Metrics data for this file is not properly formatted. ");
    } // Bot speaker column should not display for speech media types


    var filteredSpeakers = Object.keys(speakers).filter(function (speaker) {
      return isChatTextMedia ? speaker !== "CALLER" : speaker !== "BOT" && speaker !== "CALLER";
    });
    return /*#__PURE__*/_react["default"].createElement(StyledMetrics, null, metrics.map(function (group) {
      return /*#__PURE__*/_react["default"].createElement(StyledColumn, {
        key: title + "_" + group.metricGroupName
      }, /*#__PURE__*/_react["default"].createElement(StyledRow, null, /*#__PURE__*/_react["default"].createElement("div", null), filteredSpeakers.map(function (speaker) {
        return /*#__PURE__*/_react["default"].createElement("h4", {
          className: "fw5"
        }, speakers[speaker]);
      })), /*#__PURE__*/_react["default"].createElement(_MetricGroup["default"], _extends({}, group, {
        filteredSpeakers: filteredSpeakers
      })));
    }));
  };

  return Index;
}(_react["default"].PureComponent);

var _default = Index;
exports["default"] = _default;